<button *ngIf="false" class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
    <mat-icon>close</mat-icon>
</button>

<div class="dialog-content">
    <h3 [innerHTML]="'deliveryDefenseAgreementBeta.title' | translate" class="title"></h3>
    <div class="content">
        <div *ngIf="agreement$ | async as agreement; else loading">
            <ng-container *ngIf="agreement !== 'No Terms and Conditions found'; else error">
                <div [innerHTML]="agreement.TermsConditionsText"></div>
            </ng-container>
        </div>
    </div>

    <form [formGroup]="formGroup">
        <mat-checkbox formControlName="isAgreed" class="message agree">
            <span [innerHTML]="'deliveryDefenseAgreementBeta.agree' | translate"></span>
        </mat-checkbox>

        <div class="actions">
            <button (click)="accept($event)" [disabled]="!formGroup?.valid || isAcceptingAgreement || isDecliningAgreement"
                    class="action"
                    color="primary"
                    mat-flat-button>
                <span *spinOn="isAcceptingAgreement"
                      [innerHTML]="'deliveryDefenseAgreementBeta.accept' | translate"></span>
            </button>
            <button (click)="decline($event)"
                    [disabled]="isAcceptingAgreement || isDecliningAgreement"
                    class="action"
                    mat-stroked-button>
                <span *spinOn="isDecliningAgreement"
                      [innerHTML]="'deliveryDefenseAgreementBeta.decline' | translate"></span>
            </button>
        </div>
    </form>
</div>

<ng-template #loading>Loading...</ng-template>
<ng-template #error>
    <div [innerHTML]="'deliveryDefenseAgreementBeta.failedToLoadAgreement' | translate"></div>
</ng-template>
